import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { GoogleService } from './google-service';
import { environment } from '../../environments/environment';
import { FpaTaskData } from '../model/fpa-task-data';
import { Observable } from 'rxjs';
import { FpaTaskResponse } from '../model/fpa-task-response';

@Service()
export class FpaTaskService {
  private readonly http = inject(HttpClient);
  private readonly googleService = inject(GoogleService);
  private urlBase = environment.serviceUrl + 'fpaTask/';

  getTaskData(id: number): Observable<FpaTaskData> {
    const url = this.urlBase + id;
    return this.http.get<FpaTaskData>(url, { headers: this.getRequestHeaders() });
  }

  private getRequestHeaders(): HttpHeaders {
    return new HttpHeaders().set(GoogleService.TokenHeader, this.googleService.getAccessToken());
  }

  closeTask(taskResponse: FpaTaskResponse): Observable<string> {
    const url = this.urlBase + 'closeTask';
    const body = JSON.stringify(taskResponse);
    return this.http.post(url, body, {headers: this.getPostHeaders(), responseType: 'text'});
  }

  private getPostHeaders(): HttpHeaders {
    return this.getRequestHeaders().set("Content-Type", "application/json");
  }
}
